import React from 'react'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

import StandSelect from './StandSelect'
import OptionsSelect from 'src/components/OptionsSelect'

export enum SearchType {
  DISTRICT = 'district',
  STAND = 'stand',
}

type Props = {
  isSessionShowAll?: boolean
  isStandShowAll?: boolean
} & SelectProps

export default function SearchRangeSelect({
  isSessionShowAll = true,
  isStandShowAll = false,
  ...props
}: Props) {
  const { t } = useTranslation()

  const [searchType, setSearchType] = React.useState<SearchType>(
    SearchType.DISTRICT
  )

  const [district, setDistrict] = React.useState<any>('')
  const [stand, setStand] = React.useState<any>('')

  const handleChangeSearchType = (val: any) => {
    setSearchType(val)
    setStand('')
    setDistrict('')
  }

  const handleChangeSession = (val: any) => {
    setDistrict(val)
  }

  const handleChangeStand = (val: any) => {
    setStand(val)
  }

  return (
    <div className="flex">
      <Select
        {...props}
        style={{
          width: '100px',
          marginRight: '10px',
        }}
        onChange={handleChangeSearchType}
        defaultValue={searchType}
        value={searchType}>
        <Select.Option value={SearchType.DISTRICT}>行政區</Select.Option>
        <Select.Option value={SearchType.STAND}>站點</Select.Option>
      </Select>

      {searchType === SearchType.DISTRICT && (
        <OptionsSelect.SessionSelect className="w-full" />
      )}

      {searchType === SearchType.STAND && (
        <StandSelect
          loading={false}
          onChange={handleChangeStand}
          defaultValue={stand}
          value={stand}
        />
      )}
    </div>
  )
}
